<template>
	<div class="avatar">
		<a-avatar :shape="shape" v-if="url" :size="size" :src="filePreview(url)" />
		<a-avatar :shape="shape" v-else-if="name" :size="size" class="avatar-name">{{ name.charAt(0) }}</a-avatar>
		<a-avatar :shape="shape" v-else :size="size" />
	</div>
</template>

<script>
export default {
	name: "ZjyAvatar",
	props: {
		url: {
			type: String,
			required: false
		},
		shape: {
			type: String,
			default: 'square'
		},
		name: {
			type: String,
			required: false
		},
    size: {
      type: Number,
      default: 35
    },
	}
}
</script>

<style scoped lang="less">
.avatar-name{
  color: #fff;
  background: #3e7dff
}
</style>
